import React, { useEffect, useMemo, useState } from 'react';
import { getMapPlottableOrders } from './mapOrderTrackingModel';
import { MAP_MARKER_VIEW } from './constants';
import { OrdersTrackingPanel } from './OrdersTrackingPanel';
import { TrackingMap } from './TrackingMap';
import { useInHouseDeliveryOrders } from './useInHouseDeliveryOrders';
import './OrderTrackingDashboard.scss';

export function OrderTrackingDashboard({ branchLabel = 'Kitchen', orders: ordersProp }) {
  const ordersFromContext = useInHouseDeliveryOrders();
  const orders = ordersProp ?? ordersFromContext;

  const [selectedId, setSelectedId] = useState(null);
  const [mapStyle, setMapStyle] = useState('roadmap');
  const [mapMarkerView, setMapMarkerView] = useState(MAP_MARKER_VIEW.RESTAURANT);
  const [mapRef, setMapRef] = useState(null);

  const listOrders = orders.filteredOrders;
  const mapOrders = getMapPlottableOrders(listOrders);
  const ordersWithoutMap = listOrders.length - mapOrders.length;

  const selectedOrder = useMemo(() => {
    if (!selectedId) return null;
    return listOrders.find((o) => o.id === selectedId) ?? null;
  }, [listOrders, selectedId]);

  useEffect(() => {
    if (!selectedId) return;
    if (!listOrders.some((o) => o.id === selectedId)) setSelectedId(null);
  }, [listOrders, selectedId]);

  const handleSelectOrder = (id) => {
    setSelectedId((prev) => (prev === id ? null : id));
  };

  return (
    <div className='otd-layout'>
      <div className='otd-layout__body'>
        <OrdersTrackingPanel
          regionalBranch={branchLabel}
          loading={orders.loading}
          loadError={orders.loadError}
          filteredCount={orders.filteredOrders.length}
          totalCount={orders.totalCount}
          listCount={listOrders.length}
          mapCount={mapOrders.length}
          ordersWithoutMap={ordersWithoutMap}
          orders={listOrders}
          selectedId={selectedId}
          onSelectOrder={handleSelectOrder}
          statusFilter={orders.statusFilter}
          onStatusFilterChange={orders.setStatusFilter}
          statusTabCounts={orders.tabCounts}
          orderIdSearch={orders.orderIdSearch}
          onOrderIdSearchChange={orders.setOrderIdSearch}
        />
        <TrackingMap
          orders={mapOrders}
          selectedOrder={selectedOrder}
          selectedId={selectedId}
          mapMarkerView={mapMarkerView}
          mapStyle={mapStyle}
          onMapStyleChange={setMapStyle}
          onCloseTimeline={() => setSelectedId(null)}
          onSelectOrder={handleSelectOrder}
          mapRef={mapRef}
          setMapRef={setMapRef}
        />
      </div>
    </div>
  );
}
